import { render, staticRenderFns } from "./user-tag.vue?vue&type=template&id=30dd48c8&"
import script from "./user-tag.vue?vue&type=script&lang=js&"
export * from "./user-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30dd48c8')) {
      api.createRecord('30dd48c8', component.options)
    } else {
      api.reload('30dd48c8', component.options)
    }
    module.hot.accept("./user-tag.vue?vue&type=template&id=30dd48c8&", function () {
      api.rerender('30dd48c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/user-tag.vue"
export default component.exports